// @view/panels/authentication/EmailValidationBody.panel.tsx
import React from "react";
import type { EmailValidationPhase } from "@ps-bridge/models/ui/emailValidationPhase";
import type { EmailValidationViewProps } from "@ps-bridge/contracts/emailValidation";
import EmailValidationBodyIdleView from "@view/authentication/EmailValidationBodyIdle.view";
import EmailValidationBodyLoadingView from "@view/authentication/EmailValidationBodyLoading.view";
import EmailValidationBodySuccessView from "@view/authentication/EmailValidationBodySuccess.view";
import EmailValidationBodyErrorView from "@view/authentication/EmailValidationBodyError.view";

type EmailValidationBodyPanelProps = Pick<
  EmailValidationViewProps,
  "bodyPhase" | "errorMessage" | "onNavigateToHome" | "onNavigateToLogin"
>;

const EmailValidationBodyPanel: React.FC<EmailValidationBodyPanelProps> = ({
  bodyPhase,
  errorMessage,
  onNavigateToHome,
  onNavigateToLogin,
}) => {
  const phaseKeys = {
    idle: "idle",
    loading: "loading",
    success: "success",
    error: "error",
  } as const satisfies Record<EmailValidationPhase, EmailValidationPhase>;

  const render = {
    [phaseKeys.idle]: <EmailValidationBodyIdleView />,
    [phaseKeys.loading]: <EmailValidationBodyLoadingView />,
    [phaseKeys.success]: <EmailValidationBodySuccessView onNavigateToHome={onNavigateToHome} />,
    [phaseKeys.error]: (
      <EmailValidationBodyErrorView
        errorMessage={errorMessage}
        onNavigateToLogin={onNavigateToLogin}
      />
    ),
  } as const satisfies Record<EmailValidationPhase, React.ReactElement>;

  return render[bodyPhase as keyof typeof render];
};

export default React.memo(EmailValidationBodyPanel, (prevProps, nextProps) => {
  return (
    prevProps.bodyPhase === nextProps.bodyPhase &&
    prevProps.errorMessage === nextProps.errorMessage
  );
});
